<template>
    <div class="paid-voice">
        <div class="paid-voice-mask" v-if="showPaidVoice" @click="close"></div>
        <div class="paid-voice-box" v-if="showPaidVoice">
            <div class="box">
                <div class="tips">此语音为付费语音</div>
                <div class="tips">需要付费支付 <span>{{ data.audio_price }}</span> 元</div>
                <div class="tips" v-if="isWeiXin">是否支付？</div>
                <div class="btns">
                    <div class="btn" @click="close">放弃</div>
                    <div class="btn active" @click="toPay" v-if="isWeiXin">去支付</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'mint-ui'
import Apis from '../../config/apis'
import _ from '../../config/util'
export default {
    props: {
        showPaidVoice: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            sid: this.$route.query.id,
            uid: this.$route.query.uid,
        }
    },
    computed: {
        isWeiXin() {
            return this.$store.state.isWeiXin
        },
    },
    methods: {
        close() {
            this.$emit('update:showPaidVoice', false)
        },
        toPay() {
            if (!this.uid) {
                Toast('您还未登录请先登录再继续')
                setTimeout(() => {
                    let url = '/pages/member/login/index?is_back=1'
                    window.uni.miniProgram.navigateTo({
                        url
                    })
                }, 1500)
                return
            }
            // window.uni.miniProgram.getBrandWCPayRequest()
            window.uni.miniProgram.navigateTo({
                url: `/packages/pay_result/pay/index?type=18&id=${this.data.id}`
            })

            let refresh = () => {
                // 转换坐标 （使用百度接口转高德为百度坐标）
                let userPosition = this.$store.state.userLocation
                const tramRes = _.bd_encrypt(userPosition[0], userPosition[1])
                const params = {
                    cid: this.$store.state.curClassify.id,
                    classify_id: this.$store.state.curClassify.id,
                    sid: this.sid,
                    lng: tramRes.lng,
                    lat: tramRes.lat,
                    uid: this.uid,
                }
                let spotsUrl = Apis.spots
                if(this.sid) spotsUrl = Apis.spots1
                this.axios.post(spotsUrl, params).then((res) => {
                    // 最终结果
                    const zzRes = res.data,
                    item = zzRes.find(v => v.id == this.data.id)
                    // 已支付
                    if(item.is_paid == 1) {
                        // 设置当前选择的点
                        this.$store.commit('setCurScenicItem', item)
                        this.$store.commit('setCurScenicList', zzRes)
                        this.$emit('update:showPaidVoice', false)
                    } else if (this.showPaidVoice) { // 只要支付弹窗没关掉就一直刷新
                        setTimeout(() => {
                            refresh()
                        }, 500)
                    }
                    // 绘制点
                })
            }
            refresh() // 刷新数据判断有没有支付成功
        },
    }
}
</script>

<style lang="scss" scoped>
.paid-voice {
    --default-z-index: 10000;
    .paid-voice-mask {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: .5);
        z-index: var(--default-z-index);
    }
    .paid-voice-box {
        line-height: 1;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: linear-gradient(180deg, #206864 0%, #67BBA6 100%);
        border-radius: .29rem;
        padding: .1rem .12rem;
        z-index: var(--default-z-index);
        .box {
            width: 5.4rem;
            background: #FFFFFF;
            border-radius: .29rem;
            padding-top: .8rem;
            padding-bottom: .4rem;
            text-align: center;
            .tips {
                font-weight: 500;
                font-size: .32rem;
                color: #121212;
                line-height: 1.8;
            }
            .btns {
                display: flex;
                justify-content: center;
                gap: .4rem;
                margin-top: .8rem;
                .btn {
                    width: 2rem;
                    height: .68rem;
                    line-height: .68rem;
                    border-radius: .34rem;
                    border: 2px solid #C5C5C5;
                    font-weight: 400;
                    font-size: .28rem;
                    color: #212121;
                    box-sizing: border-box;
                    &.active {
                        background: #206864;
                        border: none;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
}
</style>